import { Observable } from "rxjs";
import { BRAND_REORDER_EXCLUSIONS_UPDATE, BRAND_REORDER_EXCLUSIONS_UPDATE_COMPLETE } from "constants/action-types";
import siteConfig from "site-config";
import { formatMessage } from "lib/globalize-util";
import { ajax } from "lib/observable";
import "rxjs/add/operator/map";
import { add as snackbarAdd } from "actions/snackbars";

export const updateReOrderExclusionsEpic = (action$, store) => {
    return action$
        .ofType(BRAND_REORDER_EXCLUSIONS_UPDATE)
        .map((action) => {
            return action.payload;
        })
        .concatMap((terms) => {
            const data = terms ? terms : undefined; // weird legacy api hack
            return ajax({
                method: "POST",
                body: {
                    reorder_field_exclusions: data,
                },
                url: `${siteConfig.api}/brand/orders/reorder-field-exclusions`,
            })
                .map(({ response, status }) => {
                    if (response && status === 200) {
                        return { result: response, error: false };
                    } else {
                        return { error: true, result: [] };
                    }
                })
                .flatMap(({ result, error }) => {
                    if (error) {
                        return [
                            store.dispatch(snackbarAdd({ message: "Error saving re-order fields" })),
                            {
                                payload: [],
                                error: true,
                                type: BRAND_REORDER_EXCLUSIONS_UPDATE_COMPLETE,
                            },
                        ];
                    } else {
                        return [
                            {
                                payload: result,
                                type: BRAND_REORDER_EXCLUSIONS_UPDATE_COMPLETE,
                            },
                            snackbarAdd({ message: "Re-order fields updated" }),
                        ];
                    }
                })
                .catch((error) => {
                    let errorMessage = formatMessage("Error saving re-order fields");
                    if (error.status === 401) {
                        errorMessage = formatMessage("You do not have permission to edit re-order fields");
                    }
                    return Observable.merge(
                        Observable.of({
                            error: true,
                            payload: new Error(errorMessage),
                            type: BRAND_REORDER_EXCLUSIONS_UPDATE_COMPLETE,
                        }),
                        Observable.of(snackbarAdd({ message: errorMessage })),
                    );
                });
        });
};
